// extracted by mini-css-extract-plugin
export var contentBody = "_c2-9";
export var headerImage = "_c2-2";
export var imageButton = "_c2-7";
export var imageButtonIcon = "_c2-8";
export var imageHeader = "_c2-4";
export var imageHeaderText = "_c2-5";
export var imageOverlay = "_c2-3";
export var imageTitle = "_c2-6";
export var imageWrapper = "_c2-1";
export var taskList = "_c2-a";
export var widget = "_c2-0";